import AsyncStorage from "@react-native-async-storage/async-storage";
import { clientConfigPath, CMSPath } from "../../config/Constant";
import { Alert, BackHandler, Linking, Platform } from "react-native";
import DeviceInfo from 'react-native-device-info';
import { setAppUpdateDenied, setLayoutCssData } from "../Reducers/appConfigReducer";
import { updateDynamicStyle } from "../Reducers/dynamicStyleSheetReducer";
import { setChatInterface, setInnspireOneConfigs } from "../Reducers/appPreservedConfigReducer";

export const fetchAppConfig = () => {


    return async (dispatch, getState) => {

        const { appVersion, appBuildNumber, appUpdateDenied } = getState().appConfigSlice;

        try {
            const sessionToken = await AsyncStorage.getItem('sessionToken');
            const DeviceIdentifier = await AsyncStorage.getItem('DeviceIdentifier');

            let room = await AsyncStorage.getItem('room') || "notLogin";

            const applicationId = DeviceInfo.getBundleId(); // Get application ID
            const osType = Platform.OS; // 'android' , 'ios' or web

            console.log('fetchAppConfig', applicationId, osType, appBuildNumber);

            const response = await clientConfigPath.post(
                `/core/configsFetch?dId=${DeviceIdentifier}&rn=${room}`,
                {
                    "header": {
                        "sessionToken": sessionToken
                    },
                    "payload": {
                        "actionKey": "guestJourneyConfigData",
                        "applicationID": applicationId,
                        "osType": osType,
                        "osVersion": appBuildNumber
                    }
                }
            );

            const payload = response?.data?.payload || {};
            console.log("App Config response:", payload)

            const latestVersion = payload.availableVersion;
            const forceUpdate = payload.forceUpdate;
            const appUrl = payload.appUrl;

            if (+latestVersion > +appBuildNumber && !appUpdateDenied) {

                const buttons = [
                    !forceUpdate && {
                        text: 'Cancel',
                        onPress: async () => {
                            dispatch(setAppUpdateDenied(true));
                        },
                    },
                    {
                        text: 'Update',
                        onPress: async () => {
                            if (!forceUpdate) {
                                dispatch(setAppUpdateDenied(true));
                            }
                            await Linking.openURL(appUrl);
                        },
                    },
                ].filter(Boolean);

                Alert.alert(
                    'App Update',
                    forceUpdate
                        ? 'To continue using this app, please update to get the latest improvements.'
                        : 'Please update to the latest version to get the latest improvements.',
                    buttons,
                    { cancelable: false }
                );
            }

            dispatch(setChatInterface(payload?.chatInterface))
            dispatch(setInnspireOneConfigs(payload?.innspireOneConfigs))
            dispatch(setLayoutCssData(payload?.layoutCssData))
        } catch (error) {
            console.log("Error in fetching api config", error);
        }
    };
};